<template>
  <div class="box">
    <Tag v-if="datas && datas.tags.length" :datas="datas.tags" />
    <div class="name">
      <span>
        {{ datas.brand.name }}
        {{ datas.moe ? `原配${datas.moe}` : '' }}
        {{ datas.spec }}&nbsp;{{ datas.load_index }}{{ datas.speed_rating }}&nbsp;{{ datas.extra_load }}&nbsp;{{ datas.pattern }}
      </span>
      &nbsp;
    </div>
     <div v-if="tyrePackageLoyaltyList?.length>0" class="brands">
       <div class="tyrePlan">
           <div v-for="(item,index) in tyrePackageLoyaltyList" :key="index">已绑定{{item.loyaltyName}}</div>
       </div>
    </div>
    <div class="brands">
      <Coupon v-if="couponList.length" :datas="couponList" />
    </div>
    <!-- <div v-if="!max" class="noGoodsTip">您所在经销商当前无供货，请联系工作人员检查库存及时上架</div> -->
    <div class="fvlr">
      <div class="price">
        <span class="msrp">¥{{ datas.msrp }}</span
        >&nbsp;&nbsp;厂商建议零售价*
      </div>
      <van-stepper v-if="max" class="stepper" v-model="value" :max="max" @plus="plus" />
    </div>
    <MsrpExplain sign="tyre" />
    <div class="tip">
      上述厂商建议零售价及工时费仅为建议，不具有任何约束力。 最终成交价格以经销商实际报价为准。
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch } from 'vue'
import { Toast } from 'vant'
import Tag from '@/components/tyre/Tag.vue'
import Coupon from '@/components/tyre/Coupon.vue'
import MsrpExplain from '@/components/common/MsrpExplain.vue'
import { useStore } from 'vuex'
export default {
  components: {
    Tag,
    Coupon,
    MsrpExplain
  },
  props: ['datas', 'couponList', 'notSell','tyrePackageLoyaltyList'],
  setup(props) {
    let { datas, couponList, notSell,tyrePackageLoyaltyList } = toRefs(props)
    let store = useStore()
    const state = reactive({
      tyrePackageLoyaltyList,
      value: 1,
      datas,
      couponList,
      max: 1,
      notSell
    })
    const setStepperOption = option => {
      store.commit('SETSTEPPEROPTION', {
        ...store.state.stepperOption,
        ...option
      })
    }
    const plus = () => {
      let { dealerInfo } = store.state
      if (!dealerInfo.address) {
        Toast({
          message: '请先选择经销商',
          position: 'bottom'
        })
      }
    }
    const getStock = async () => {
      let { dealer_stock, two_hours_stock, stock } = store.state.dealerInfo
      const twoStock = Number(dealer_stock + two_hours_stock)
      const nextStock = Number(dealer_stock + stock)
      const maxStock = Math.max.apply(Math, [twoStock, nextStock])
      let stockAmount = Math.min.apply(Math, [maxStock, 4])
      state.max = isNaN(stockAmount) ? 0 : stockAmount
      setStepperOption({ max: stockAmount })
    }
    watch(
      () => store.state.dealerInfo,
      n => {
        if (!n.gs_code) return
        getStock()
      },
      {
        deep: true
      }
    )
    watch(
      () => state.value,
      n => {
        setStepperOption({ value: n })
      }
    )
    onMounted(() => {
      setStepperOption({ value: state.value, max: state.max })
      if (store.state.dealerInfo && store.state.dealerInfo.gs_code) {
        getStock()
      }
    })
    return {
      ...toRefs(state),
      plus
    }
  }
}
</script>

<style lang="scss" scoped>
.tyrePlan{
    div{
      font-size: 12px;
      padding: 1px 8px;
      margin-right: 8px;
      border-radius: 18px;
      border: 1px solid #3088c5;
      color: #3088c5;
      display: inline-block;
      margin-bottom: 8px;
    }
}
.box {
  padding: 12px 20px;
  box-sizing: border-box;
  background: #ffffff;
}
.name {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  flex-wrap: wrap;
  text-align: left;
  &::after {
    content: '';
    width: 100%;
  }
}
.tip {
  font-size: 12px;
  color: #999999;
  margin-top: 8px;
  text-align: justify;
}

.brands {
  font-size: 14px;
  color: #666666;
  text-align: left;
  margin: 8px 0;
}
.price {
  font-size: 14px;
  color: #666666;
}
.msrp {
  font-size: 20px;
  color: #3088c5;
  font-weight: bold;
}
.stepper {
  transform: scale(0.8);
}
.noGoodsTip {
  font-size: 12px;
  color: red;
  margin: 5px 0;
  text-align: left;
}
</style>
